import type { Integration, IntegrationKind } from "@lumen/shared";
import { catalogPart1 } from "./IntegrationsCatalogPart1";
import { catalogPart4 } from "./IntegrationsCatalogPart4";
import { catalogPart2 } from "./IntegrationsCatalogPart2";
import { catalogPart3 } from "./IntegrationsCatalogPart3";
export {
  capabilityIcons,
  capabilityLabels,
  textField,
  tokenField,
} from "./IntegrationsCatalogShared";
export type {
  ActionApproval,
  Capability,
  Config,
  Draft,
  Field,
  IntegrationDefinition,
} from "./IntegrationsCatalogShared";
export { iconFor } from "../../components/integrations/IntegrationsIcon";
import type {
  Config,
  Draft,
  IntegrationDefinition,
} from "./IntegrationsCatalogShared";

export const catalog: IntegrationDefinition[] = [
  ...catalogPart1,
  ...catalogPart4,
  ...catalogPart2,
  ...catalogPart3,
];

export const groups = [
  "Messaging",
  "Productivity",
  "Knowledge",
  "Operations",
  "Marketing",
  "Analytics",
  "Developer",
  "Restaurant operations",
  "Finance & payments",
  "Local business",
  "People & sourcing",
];

export const groupLabels: Record<string, string> = {
  Messaging: "Messages & notifications",
  Productivity: "Calendars & scheduling",
  Knowledge: "Files & knowledge",
  Operations: "CRM & support",
  Marketing: "Publishing & campaigns",
  Analytics: "Reporting & insights",
  Developer: "Code & repositories",
  "Restaurant operations": "Restaurants & hospitality",
  "Finance & payments": "Finance & payments",
  "Local business": "Local business data",
  "People & sourcing": "People & food supply",
};

export const businessIntegrationKinds = new Set<IntegrationKind>([
  "restolution",
  "lightspeed_restaurant",
  "deliverect",
  "thefork",
  "zenchef",
  "wolt_drive",
  "netvisor",
  "billit",
  "paytrail",
  "payconiq",
  "bancontact",
  "google_business_profile",
  "sd_worx",
  "acerta",
  "partena_professional",
  "securex",
  "liantis",
  "ytj_prh",
  "cbe_kbo",
  "vies",
  "gs1_food_data",
  "kespro",
  "procountor",
  "fennoa",
  "mollie",
  "odoo",
  "tripadvisor",
  "tableonline",
  "resdiary",
  "just_eat",
  "foodora",
  "peppol_gateway",
  "stripe",
  "sumup",
  "mobilepay",
  "klarna",
  "uber_eats",
  "deliveroo",
  "bolt_food",
  "resq_club",
  "opentable",
  "tablebooker",
  "resengo",
  "visma_eaccounting",
  "exact_online",
  "teamleader",
  "clearfacts",
  "doccle",
  "unifiedpost",
  "palkka_fi",
  "sympa",
  "metro_tukku",
  "meira_nova",
  "ponto",
  "fivaldi",
  "etasku",
  "mepco",
  "palkkaus_fi",
  "ucm",
  "yuki",
  "octopus",
  "horus",
  "winbooks",
  "worldline",
  "nets_nexi",
  "e_invoice_be",
]);

export function definitionFor(kind: IntegrationKind) {
  return catalog.find((entry) => entry.kind === kind);
}

export function initialConfig(kind: IntegrationKind): Config {
  const definition = definitionFor(kind);
  return Object.fromEntries(
    (definition?.fields ?? [])
      .filter((field) => field.defaultValue !== undefined)
      .map((field) => [field.key, field.defaultValue as string]),
  );
}

export function emptyDraft(kind: IntegrationKind = "mailbox"): Draft {
  return {
    name: definitionFor(kind)?.label ?? "New integration",
    scope: "personal",
    kind,
    config: initialConfig(kind),
  };
}

export function draftForIntegration(item: Integration): Draft {
  return { name: item.name, scope: item.scope, kind: item.kind, config: {} };
}
